import { forwardRef, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '../../lib/utils';

/** Labeled text input with optional password reveal + error state. */
const Input = forwardRef(function Input(
  { label, type = 'text', error, className, icon: Icon, id, ...props },
  ref
) {
  const [show, setShow] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (show ? 'text' : 'password') : type;
  const inputId = id || props.name;

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={inputId} className="mb-1.5 block text-sm font-medium text-content-muted">
          {label}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <Icon className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-content-subtle" />
        )}
        <input
          ref={ref}
          id={inputId}
          type={inputType}
          className={cn(
            'glass h-11 w-full rounded-lg px-3.5 text-sm text-content placeholder:text-content-subtle',
            'transition-colors focus-visible:ring-2 focus-visible:ring-brand-400',
            Icon && 'pl-10',
            isPassword && 'pr-10',
            error && 'ring-2 ring-danger/70',
            className
          )}
          {...props}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShow((s) => !s)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-content-subtle transition-colors hover:text-content"
            aria-label={show ? 'Hide password' : 'Show password'}
          >
            {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        )}
      </div>
      {error && <p className="mt-1.5 text-xs text-danger">{error}</p>}
    </div>
  );
});

export default Input;
